import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import { Dialog, TableRow, TableCell, Tooltip, IconButton, } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"
import ShowAttachments from "../../../../shared_elements/components/ShowAttachments"
import { dayMonthDateFormat, fieldDMYShort } from "../../../../constants"
import AttachFileIcon from "@material-ui/icons/AttachFile"
import moment from "moment"
import { fillEditFromApi } from "../apiService"
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory"
import { permissionCheckFnforCamo, checkApiStatus } from "../../../../utils"
import { globalPutService, globalDeleteService } from "../../../../utils/globalApiServices"
import { acumenCamo } from "../../../../shared_elements/components"

const SrList = ({ item, index, toggleDelteModalFn, onEditFn, props, fileUploadData, currentRecordPerPage, downloadAllApi, uuid, last_used_folder_uuid, last_used_folder_uuid_link_document, checkbox_last_used_folder_uuid, getResponseBack, checkbox_last_used_folder_name, assetsDetail }) => {
	const [showFullDescription, setShowFullDescription] = useState({})
	const [openGetAttachmentsDialogue, setAttachmentsDialogue] = useState(false)
	const [AllAttachmentsforDialogue, setAllAttachmentsforDialogue] = useState(null)
	const [moduleId, setmoduleId] = useState(null)

	const handleEditRow = () => {
		fillEditFromApi(item, props).then((response) => {
			onEditFn({
				editFormId: response.data.data.id,
				editFormData: response.data.data,
				attachments: response.data.data.attachments,
			})
		})
	}

	const downAllAttach = () => {
		fillEditFromApi(item, props).then((response) => {
			setmoduleId(response.data.data.id)
		})
		getAttachements()
	}

	const getAttachements = () => {
		const matchingItem = assetsDetail?.list?.find(items => items?.id === item.id);
		if (!matchingItem) return [];
		const { checklist, attachments } = matchingItem || {};
		if (checklist && attachments || checklist || attachments) {
			const { files, folders } = checklist || {};
			if (attachments?.length > 0 && files?.length > 0 && folders?.length > 0) {
				getAttachments([...attachments, ...files, ...folders])
			} else if (files?.length > 0 && folders?.length > 0) {
				getAttachments([...folders, ...files])
			} else if (attachments?.length > 0 && files?.length > 0) {
				getAttachments([...attachments, ...files])
			} else if (attachments?.length > 0 && folders?.length > 0) {
				getAttachments([...attachments, ...folders])
			} else if (attachments?.length > 0) {
				getAttachments([...attachments])
			} else if (folders?.length > 0) {
				getAttachments([...folders])
			} else if (files?.length > 0) {
				getAttachments([...files])
			}
		}
		return [];
	}

	const openAttachment = (file) => {
		var decodedURL = decodeURIComponent(file);
		window.open(decodedURL, "_blank");
	}

	const formatDate = (date) => {
		return moment(date).format("DD-MM-YYYY")
	}

	const toggleDescription = (id) => {
		setShowFullDescription({
			...showFullDescription,
			[id]: !showFullDescription[id],
		})
	}

	const getAttachments = (attachments) => {
		setAllAttachmentsforDialogue(attachments)
		setAttachmentsDialogue(true)
	}

	const handleCloseAttachmentDialogue = () => {
		setAttachmentsDialogue(false)
	}

	const convertToDate = (value) => {
		if (typeof value === "string") {
			return formatDate(value)
		} else if (typeof value === "number") {
			return value
		} else {
			return "--"
		}
	}

	let timezone = moment().format()
	const timestamp = Math.floor(Date.now() / 1000);
	const srurl = `audit/camo/repairlist/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`

	const removeAttachment = (item, checklist, fileId, uuid) => {
		if (uuid) {
			let payload = {};
			payload.delete = true;
			payload.folder_ids = checklist.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).toString()
			payload.file_ids = checklist.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).toString()
			globalPutService(`camo/repair/${item?.id}/document-checklists/`, payload)
				.then((response) => {
					if (checkApiStatus(response)) {
						fillEditFromApi(item, props).then((response) => {
							const matchingItem = response.data.data;
							if (!matchingItem) return [];
							const { checklist, attachments } = matchingItem || {};
							if (checklist && attachments || checklist || attachments) {
								if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0 && item?.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data?.data?.checklist?.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response?.data?.data?.checklist?.files])
								} else if (item.checklist?.files?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0) {
									getAttachments([...response.data.data.attachments])
								} else if (item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.folders])
								} else if (item.checklist?.files?.length > 0) {
									getAttachments([...response?.data?.data?.checklist?.files])
								}
								getResponseBack()
							}
							return [];
						});
					}
				})
		} else {
			globalDeleteService(`camo/attachment/${fileId}/delete/`).then((response) => {
				if (response.status === 500) {
					props.enqueueSnackbar("Something went wrong.", {
						variant: "error",
						anchorOrigin: { vertical: "top", horizontal: "right" },
					});
				} else {
					if (response) {
						fillEditFromApi(item, props).then((response) => {
							const matchingItem = response.data.data;
							if (!matchingItem) return [];
							const { checklist, attachments } = matchingItem || {};
							if (checklist && attachments || checklist || attachments) {
								if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0 && item?.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data?.data?.checklist?.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response?.data?.data?.checklist?.files])
								} else if (item.checklist?.files?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0) {
									getAttachments([...response.data.data.attachments])
								} else if (item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.folders])
								} else if (item.checklist?.files?.length > 0) {
									getAttachments([...response?.data?.data?.checklist?.files])
								}
								getResponseBack()
							}
							return [];
						});
					}
				}
			});
		}
	};

	function getAttachmentCount(item) {
		const { attachments, checklist } = item;
		const { files, folders } = checklist || {};
		const attachmentCount = attachments?.length || 0;
		const fileCount = files?.length || 0;
		const folderCount = folders?.length || 0;
		if (attachmentCount && fileCount && folderCount) {
			return attachmentCount + fileCount + folderCount;
		} else if (fileCount && folderCount) {
			return fileCount + folderCount;
		} else if (attachmentCount && folderCount) {
			return attachmentCount + folderCount;
		} else if (attachmentCount && fileCount) {
			return attachmentCount + fileCount;
		} else {
			return folderCount || fileCount || attachmentCount || '--';
		}
	}
	const attachmentCount = getAttachmentCount(item);

	return (
		<>
			<TableRow
				hover
				tabIndex={-1}
				style={{ cursor: "pointer" }}
				className="engine-module-table"
			>
				<TableCell>
					<div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
						{permissionCheckFnforCamo({ primaryKey: "repair", keyIndex: "U", }) ? (
							<Tooltip title="Edit" arrow placement="top">
								<CreateOutlinedIcon color="primary" className="amp-table__edit-icon" onClick={(e) => { handleEditRow(e) }} />
							</Tooltip>
						) : null}
						{permissionCheckFnforCamo({ primaryKey: "repair", keyIndex: "D", }) ||
							permissionCheckFnforCamo({ primaryKey: "repair", keyIndex: "OD", userId: item.created_by, }) ? (
							<Tooltip title="Delete" arrow placement="top">
								<DeleteOutlinedIcon color="secondary" className="amp-table__delete-icon" onClick={toggleDelteModalFn} />
							</Tooltip>
						) : null}
						<RevisionHistory buttonType={true} url={srurl} />
					</div>
				</TableCell>
				<TableCell>{item.ata_chapter ? item.ata_chapter : "--"}</TableCell>
				<TableCell> {item.repair_ref_number ? item.repair_ref_number : "--"} </TableCell>
				<TableCell>{item.repair_type ? item.repair_type : "--"}</TableCell>
				<TableCell style={{ width: "200px", textAlign: "left" }}>
					{item.repair_description && item.repair_description.length > 150 ? (
						<div>
							{showFullDescription[item.id] ? (
								<span>
									{item.repair_description}
									<a href="#" style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id) }}>..less</a>
								</span>
							) : (
								<span>
									{item.repair_description.substring(0, 150)}
									<a href="#" style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id) }}>..more</a>
								</span>
							)}
						</div>
					) : item.repair_description && item.repair_description.length <= 150 ? (
						<span>{item.repair_description}</span>
					) : (
						"--"
					)}
				</TableCell>
				<TableCell> {item.repeat_inspection ? item.repeat_inspection : "--"} </TableCell>
				<TableCell> {item.repair_location ? item.repair_location : "--"} </TableCell>
				<TableCell>{item.repair_detail ? item.repair_detail : "--"}</TableCell>
				<TableCell> {item.repair_compliance_ref ? item.repair_compliance_ref : "--"} </TableCell>
				<TableCell> {item.repair_compliance_date ? moment(item.repair_compliance_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"} </TableCell>
				<TableCell> {item.repair_compliance_tsn ? item.repair_compliance_tsn : "--"} </TableCell>
				<TableCell> {item.repair_compliance_csn ? item.repair_compliance_csn : "--"} </TableCell>
				<TableCell>{convertToDate(item?.remaining?.due_at)}</TableCell>
				<TableCell> {item.last_done_date ? moment(item.last_done_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"} </TableCell>
				<TableCell>{item.last_done_fh ? item.last_done_fh : "--"}</TableCell>
				<TableCell>{item.last_done_fc ? item.last_done_fc : "--"}</TableCell>
				<TableCell style={{ width: "200px", textAlign: "left" }}>
					{item.remark && item.remark.length > 150 ? (
						<div>
							{showFullDescription[item.id] ? (
								<span>
									{item.remark}
									<a href="#" style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id) }}>..less</a>
								</span>
							) : (
								<span>
									{item.remark.substring(0, 150)}
									<a href="#" style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id) }}>..more</a>
								</span>
							)}
						</div>
					) : item.remark && item.remark.length <= 150 ? (
						<span>{item.remark}</span>
					) : (
						"--"
					)}
				</TableCell>
				<TableCell>
					{attachmentCount ? (
						<>
							<Tooltip title="View Attachments">
								<span className="center" onClick={() => downAllAttach()}>
									<AttachFileIcon className="attach-icon" />
									<a href="#" style={{ color: "#0e7fe1" }}>{attachmentCount}</a>
								</span>
							</Tooltip>
						</>
					) : (
						"--"
					)}
				</TableCell>
			</TableRow>
			<Dialog
				open={openGetAttachmentsDialogue}
				onClose={handleCloseAttachmentDialogue}
				id="htDialog"
			>
				<ShowAttachments
					handleClose={() => handleCloseAttachmentDialogue()}
					handleShowAttachments={AllAttachmentsforDialogue}
					openAttachment={openAttachment}
					files={{ title: "SR", extension: "zip", key: "" }}
					downloadAllApi={downloadAllApi}
					moduleId={moduleId}
					item={item}
					removeAttachment={removeAttachment}
				/>
			</Dialog>
		</>
	)
}
export default withRouter(SrList)
